export default {
    methods: {
        showModal: function(id) {
            this.$root.$emit('bv::show::modal', id);
        },
        hideModal: function(id) {
            this.$root.$emit('bv::hide::modal', id);
        },
    }
};
  